export default __webpack_public_path__ + "static/articles-hepato-cheren-drob-3c43bb9de0a824366db74173510c78d0.jpg";